<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/setting' }">店铺设置</el-breadcrumb-item>
        <el-breadcrumb-item>店铺认证</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <div class="steps-container">
        <div class="title">
          <p>码点餐商户认证</p>
          <el-tag type="warning"
            >申请开店之前，请准备、身份证、营业执照、行业许可证。商家证件用来审核，平台保证不泄露商家信息！</el-tag
          >
        </div>
        <el-steps class="steps" :active="stepActive" :align-center="true">
          <el-step title="基本信息"></el-step>
          <el-step title="上传资质"></el-step>
          <el-step title="完成上传"></el-step>
        </el-steps>
        <div class="form-content" v-show="stepActive == 1">
          <el-form
            :model="certificationForm1"
            status-icon
            :rules="certificationFormRule1"
            ref="certificationForm1"
            label-width="100px"
            label-position="left"
            class="certification-form"
            :hide-required-asterisk="true"
          >
            <div class="inline-title">商家基本信息</div>
            <el-form-item label="店铺名称" prop="shopName">
              <el-input
                type="text"
                v-model="certificationForm1.shopName"
                placeholder="请填写店铺名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="linkName">
              <el-input
                type="text"
                v-model="certificationForm1.linkName"
                placeholder="请填写姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人电话">
              <el-input
                type="text"
                v-model="shop.shopTel"
                placeholder="请到“店铺设置”设置店铺信息"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="contactEmail">
              <el-input
                type="text"
                v-model="certificationForm1.contactEmail"
                placeholder="请填写电子邮箱"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="店铺类型" prop="shopCategoryIdTags">
                            <el-cascader
                                :props="props"
                                v-model="certificationForm1.shopCategoryIdTags"
                                clearable
                                placeholder="请选择店铺类型"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item label="门店所在地" prop="cityName">
                            <el-cascader
                                v-model="certificationForm1.cityName"
                                @change="cityNameCascaderHandler"
                                :options="cityOptions"
                                :props="{ expandTrigger: 'hover', value: 'label' }"
                                placeholder="请选择门店所在地"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item label="详细地址" prop="shopAddress">
                            <el-input
                                v-model="certificationForm1.shopAddress"
                                disabled
                                placeholder="请填写店铺地址"
                            >
                                <template slot="append">
                                    <el-button @click="showDialogMap">去定位</el-button>
                                </template>
                            </el-input>
                        </el-form-item>-->
            <el-form-item label="上传门脸照" prop="shopFaceImage">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="shopFaceImage"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'shopFaceImage', 'certificationForm1');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'shopFaceImage', 'certificationForm1');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
                :on-exceed="limitTip"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="店内照片(可多图)" prop="shopImages">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="shopImages"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'shopImages', 'certificationForm1');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'shopImages', 'certificationForm1');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="附加图" prop="attachImages">
              <div>
                <el-upload
                  action="/ImageServer/YmUpload_image"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="
                    (e) => {
                      handleRemove(e, 'attachImages', 'certificationForm1');
                    }
                  "
                  :http-request="
                    (e) => {
                      handleSuccess(e, 'attachImages', 'certificationForm1');
                    }
                  "
                  :before-upload="beforeImgUpload"
                  :file-list="attachImages"
                  :on-exceed="limitTip"
                  :limit="1"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </div>
            </el-form-item>
            <div class="inline-title">支付宝信息</div>
            <el-form-item label="支付宝账号" prop="alipayAccount">
              <el-input
                type="text"
                v-model="certificationForm1.alipayAccount"
                placeholder="个人或企业支付宝账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="支付宝姓名" prop="alipayPersonName">
              <el-input
                type="text"
                v-model="certificationForm1.alipayPersonName"
                placeholder="支付宝绑定姓名或者企业名称"
              ></el-input>
            </el-form-item>
            <div class="inline-title">收款结算银行卡信息</div>
            <el-form-item label="银行卡卡号" prop="bankAccountNo">
              <el-input
                type="text"
                v-model="certificationForm1.bankAccountNo"
                placeholder="个体法人或企业账户卡号"
              ></el-input>
            </el-form-item>
            <el-form-item label="银行卡照片" prop="shopConditionImages">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="bankFrontImage"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'bankFrontImage', 'certificationForm1');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'bankFrontImage', 'certificationForm1');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
                :on-exceed="limitTip"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="银行名称" prop="bankName">
              <el-input
                type="text"
                v-model="certificationForm1.bankName"
                placeholder="填写银行卡名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户名" prop="bankAccountName">
              <el-input
                type="text"
                v-model="certificationForm1.bankAccountName"
                placeholder="填写开户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户银行网点" prop="bankLocation">
              <el-input
                type="text"
                v-model="certificationForm1.bankLocation"
                placeholder="填写开户银行网点"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="processNext(2)"
                >提交并进入下一步</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="form-content" v-show="stepActive == 2">
          <el-form
            :model="certificationForm2"
            status-icon
            :rules="certificationFormRule2"
            ref="certificationForm2"
            label-width="100px"
            label-position="left"
            class="certification-form"
            :hide-required-asterisk="true"
          >
            <div class="inline-title">上传资质</div>
            <el-form-item label="身份证正面照" prop="idFrontImage">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="idFrontImage"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'idFrontImage', 'certificationForm2');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'idFrontImage', 'certificationForm2');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
                :on-exceed="limitTip"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="身份证反面照" prop="idBackImage">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="idBackImage"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'idBackImage', 'certificationForm2');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'idBackImage', 'certificationForm2');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
                :on-exceed="limitTip"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="手持身份证照" prop="idPersonalImage">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="idPersonalImage"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'idPersonalImage', 'certificationForm2');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'idPersonalImage', 'certificationForm2');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
                :on-exceed="limitTip"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="营业执照" prop="businessLicenceImage">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="businessLicenceImage"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'businessLicenceImage', 'certificationForm2');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'businessLicenceImage', 'certificationForm2');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
                :on-exceed="limitTip"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="行业许可证" prop="industryLicenseImage">
              <el-upload
                class="upload-demo"
                drag
                action="/ImageServer/YmUpload_image"
                multiple
                :file-list="industryLicenseImage"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'industryLicenseImage', 'certificationForm2');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'industryLicenseImage', 'certificationForm2');
                  }
                "
                :before-upload="beforeImgUpload"
                list-type="picture"
                :on-exceed="limitTip"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="processNext(3)"
                >提交并进入下一步</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="result-content" v-if="stepActive == 3">
          <div
            class="ing"
            v-if="orderStatus == 21 || orderStatus == 31 || orderStatus == 41"
          >
            <img src="@/assets/img/shop/icon-ing.png" alt />
            <p class="tips-1">上传资料成功，资料审核中。请耐心等待！</p>
            <!-- <p class="tips-2">在审核过程中，可重新编辑资料提交</p> -->
            <!-- <div class="action">
                            <el-button>撤销审核</el-button>
                            <el-button type="warning" @click="stepActive = 1">重新编辑</el-button>
                        </div>-->
          </div>
          <div class="success" v-if="orderStatus == 200">
            <img src="@/assets/img/shop/icon-success.png" alt />
            <p class="tips-1">资料审核成功，赶快添加菜品吧！</p>
            <p class="tips-2">商户认证成功</p>
            <div class="action">
              <el-button type="success" @click="linkTo('/goods/edit')"
                >添加菜品</el-button
              >
            </div>
          </div>
          <div class="fail" v-if="orderStatus == 22 || orderStatus == 32">
            <img src="@/assets/img/shop/icon-failed.png" alt />
            <p class="tips-1">资料审核成功，赶快添加菜品吧！</p>
            <p class="tips-2">商户认证成功</p>
            <p class="reason">
              <span>失败原因：</span>
              {{ orderMark }}
            </p>
            <div class="action">
              <!-- <el-button @click="stepActive = 1">重新编辑</el-button> -->
              <el-button type="danger" @click="stepActive = 1">重新编辑</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      width="510px"
      :visible.sync="dialogMapVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <div slot="title" class="dialog-title">地图定位</div>
      <!-- <baidu-map
        v-if="dialogMapVisible"
        class="map"
        :center="center"
        :zoom="zoom"
        @ready="mapReadyHandler"
        @click="getPoint"
        :scroll-wheel-zoom="true"
      >
        <bm-control :offset="{ width: '10px', height: '10px' }">
          <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
        </bm-control>
        <bm-local-search
          :keyword="keyword"
          :auto-viewport="true"
          :location="location"
          zoom="12.8"
          style="display: none"
        ></bm-local-search>
        <bm-marker :position="postionMap">
          <bm-info-window
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
            style="font-size: 14px"
          >
            <p>站点：{{ add.siteName }}</p>
            <p>站点地址：{{ add.site }}</p>
          </bm-info-window>
        </bm-marker>
      </baidu-map> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveStationAddress">保存</el-button>
      </div>
    </el-dialog>
    <baidu-map v-if="showMap" class="index-map"></baidu-map>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getShopCategorys,
  getShopApplyPayInfo,
  submitApplyPay,
  uploadImg,
} from "@/api/index.js";
import { gg2bd, bd2gg } from "@/utils/map.js";
import cityJson from "@/assets/js/citys.json";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      stepActive: 0,
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.root) {
            getShopCategorys().then((res) => {
              if (res.code == 1) {
                const nodes = Array.from(res.data).map((item) => ({
                  value: item.shopCategoryId,
                  label: item.categoryName,
                  leaf: item.level >= 2,
                }));
                resolve(nodes);
              }
            });
          } else {
            if (node.data.value == "tips") {
              return;
            }
            getShopCategorys({
              shopCategoryId: node.data.value,
            }).then((res) => {
              if (res.code == 1) {
                const nodes = Array.from(res.data).map((item) => ({
                  value: item.shopCategoryId,
                  label: item.categoryName,
                  leaf: item.level >= 2,
                }));
                resolve(nodes);
              }
            });
          }
        },
        checkStrictly: true,
      },
      certificationForm1: {
        shopName: "",
        linkName: "",
        contactEmail: "",
        // shopCategoryIdTags: "",
        // cityName: "",
        // shopAddress: "",
        attachImages: "",
        shopFaceImage: "",
        shopImages: "",
        alipayAccount: "",
        alipayPersonName: "",
        bankAccountNo: "",
        bankFrontImage: "",
        bankName: "",
        bankAccountName: "",
        bankLocation: "",
      },
      shopFaceImage: [],
      shopImages: [],
      attachImages: [],
      bankFrontImage: [],
      certificationFormRule1: {
        shopName: [
          {
            required: true,
            message: "请填写店铺名称",
            trigger: "blur",
          },
        ],
        linkName: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        contactEmail: [
          {
            type: "email",
            required: true,
            message: "请填写电子邮箱",
            trigger: "blur",
          },
        ],
        // shopCategoryIdTags: [
        //     {
        //         required: true,
        //         message: "请选择店铺类型",
        //         trigger: "blur"
        //     }
        // ],
        // cityName: [
        //     {
        //         required: true,
        //         message: "请选择门店所在地",
        //         trigger: "blur"
        //     }
        // ],
        shopFaceImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        shopImages: [
          {
            required: true,
            message: "请至少上传五张图片",
            trigger: "blur",
          },
        ],
        alipayAccount: [
          {
            required: true,
            message: "请填写支付宝账号",
            trigger: "blur",
          },
        ],
        alipayPersonName: [
          {
            required: true,
            message: "请填写支付宝姓名",
            trigger: "blur",
          },
        ],
        bankAccountNo: [
          {
            required: true,
            message: "请填写银行卡号",
            trigger: "blur",
          },
        ],
        bankFrontImage: [
          {
            required: true,
            message: "请上传银行卡正面照",
            trigger: "blur",
          },
        ],
        bankName: [
          {
            required: true,
            message: "填写银行卡名称",
            trigger: "blur",
          },
        ],
        bankAccountName: [
          {
            required: true,
            message: "填写开户名",
            trigger: "blur",
          },
        ],
        bankLocation: [
          {
            required: true,
            message: "填写开户银行网点",
            trigger: "blur",
          },
        ],
      },
      certificationForm2: {
        idFrontImage: "",
        idBackImage: "",
        idPersonalImage: "",
        businessLicenceImage: "",
        industryLicenseImage: "",
      },
      businessLicenceImage: [],
      industryLicenseImage: [],
      idFrontImage: [],
      idBackImage: [],
      idPersonalImage: [],
      certificationFormRule2: {
        idFrontImage: [
          {
            required: true,
            message: "填上传身份证正面照片",
            trigger: "blur",
          },
        ],
        idBackImage: [
          {
            required: true,
            message: "填上传身份证反面照片",
            trigger: "blur",
          },
        ],
        idPersonalImage: [
          {
            required: true,
            message: "填上传手持身份证照片",
            trigger: "blur",
          },
        ],
        businessLicenceImage: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "blur",
          },
        ],
        industryLicenseImage: [
          {
            required: true,
            message: "请上传行业许可证",
            trigger: "blur",
          },
        ],
      },
      cityOptions: cityJson,
      dialogMapVisible: false,
      mapCenter: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      cityOptions: cityJson,
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      dialogVisible: false,
      dialogImageUrl: "",
      orderStatus: 0,
      orderMark: "",
      showMap: false,
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
  },
  watch: {
    orderStatus(val) {
      if (val == 200) {
      }
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getShopApplyPayInfo();
    },
    getShopApplyPayInfo() {
      getShopApplyPayInfo().then((res) => {
        if (res.code == 1) {
          let certificationForm = JSON.parse(JSON.stringify(res.data));
          this.shopFaceImage =
            certificationForm.shopFaceImage && certificationForm.shopFaceImage.length
              ? [{ url: certificationForm.shopFaceImage }]
              : [];
          this.attachImages =
            certificationForm.attachImages && certificationForm.attachImages.length
              ? [{ url: certificationForm.attachImages }]
              : [];
          this.bankFrontImage =
            certificationForm.bankFrontImage && certificationForm.bankFrontImage.length
              ? [{ url: certificationForm.bankFrontImage }]
              : [];
          this.idFrontImage =
            certificationForm.idFrontImage && certificationForm.idFrontImage.length
              ? [{ url: certificationForm.idFrontImage }]
              : [];
          this.idBackImage =
            certificationForm.idBackImage && certificationForm.idBackImage.length
              ? [{ url: certificationForm.idBackImage }]
              : [];
          this.idPersonalImage =
            certificationForm.idPersonalImage && certificationForm.idPersonalImage.length
              ? [{ url: certificationForm.idPersonalImage }]
              : [];
          this.businessLicenceImage =
            certificationForm.businessLicenceImage &&
            certificationForm.businessLicenceImage.length
              ? [{ url: certificationForm.businessLicenceImage }]
              : [];
          // this.industryLicenseImage = certificationForm.industryLicenseImage
          //     .length
          //     ? [{ url: certificationForm.industryLicenseImage }]
          //     : [];
          res.data.industryLicenseImage = "";
          let shopImages = certificationForm.shopImages
            ? certificationForm.shopImages.split(",")
            : [];
          if (shopImages[0] && shopImages[0].length) {
            shopImages.forEach((val) => {
              this.shopImages.push({
                name: val,
                url: val,
              });
            });
          }
          this.certificationForm1 = res.data;
          this.certificationForm2 = res.data;
          this.orderMark = res.data.orderMark;
          this.orderStatus = res.data.orderStatus;
          this.stepActive = 3;
        }
        if (res.code == -1 || res.code == 0) {
          this.stepActive = 1;
        }
      });
    },
    cityNameCascaderHandler(value) {
      this.mapCenter = value.join("");
    },
    // showDialogMap() {
    //     if (!this.certificationForm1.cityName) {
    //         this.$notify({
    //             title: "警告",
    //             message: "请先选择城市",
    //             type: "warning",
    //             duration: 6000
    //         });
    //         return;
    //     }
    //     this.dialogMapVisible = true;
    // },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      this.zoom = 12.8;
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.add.lng = rs.jd;
        this.add.lat = rs.wd;
        this.bindShopForm.stationAddress = rs.address;
        this.bindShopForm.lng = rs.jd;
        this.bindShopForm.lat = rs.wd;
      });
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, name, form) {
      if (name == "shopImages") {
        let shopImages = this[form][name].split(",");
        shopImages.splice(shopImages.indexOf(file.name), 1);
        this[form][name] = shopImages.join(",");
        return;
      }
      this[form][name] = "";
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name, form) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          if (name == "shopImages") {
            if (this[form][name].length) {
              this[form][name] += `,${res.data.url}`;
            } else {
              this[form][name] = res.data.url;
            }
            return;
          }
          this[form][name] = res.data.url;
        }
      });
    },
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    processNext(index) {
      if (index == 2) {
        this.$refs.certificationForm1.validate((valid) => {
          if (valid) {
            let shopImages = this.certificationForm1.shopImages.split(",");
            if (shopImages.length < 5) {
              this.$notify({
                title: "警告",
                message: "店内图片不能少于五张", //店内图片不能少于五张
                type: "error",
              });
              return;
            }
            this.stepActive = 2;
          } else {
            this.$notify({
              title: "提示",
              message: "请完善提交内容",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        });
      }
      if (index == 3) {
        let form = Object.assign(this.certificationForm1, this.certificationForm2);
        form.linkTel = this.shop.shopTel;
        this.$refs.certificationForm2.validate((valid) => {
          if (valid) {
            submitApplyPay(form).then((res) => {
              console.log(res);
              if (res.code == 1) {
                this.stepActive = 3;
                this.orderStatus = 21;
              }
            });
          } else {
            this.$notify({
              title: "提示",
              message: "请完善提交内容",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    padding: 40px 48px;
    text-align: center;
    .steps-container {
      width: 720px;
      margin: 0 auto;
      .title {
        & > p:first-of-type {
          font-size: 24px;
          color: #409eff;
        }
        .el-tag {
          width: 720px;
          text-align: left;
          margin: 20px 0 34px;
        }
      }
      .steps {
        margin: 0 -132px;
      }
      .form-content {
        width: 70%;
        text-align: left;
        .inline-title {
          font-size: 14px;
          color: #333333;
          text-align: left;
          font-weight: bold;
          margin: 32px 0;
        }
        .el-cascader {
          width: 100%;
        }
      }
      .result-content {
        padding-top: 60px;
        .tips-1 {
          font-size: 14px;
          margin: 20px 0 10px;
          line-height: 14px;
        }
        .tips-2 {
          font-size: 12px;
          line-height: 12px;
          color: #999999;
        }
        .action {
          margin-top: 65px;
        }
        .ing {
          .tips-1 {
            color: #ffaa00;
          }
        }
        .success {
          .tips-1 {
            color: #7abd54;
          }
        }
        .fail {
          .tips-1 {
            color: #ff4c4c;
          }
          .reason {
            padding: 20px 15px;
            width: 368px;
            background: #f5f5f5;
            text-align: left;
            margin: 22px auto 0;
            font-size: 12px;
            color: #fe6b6b;
            border-radius: 4px;
            min-height: 80px;
            box-sizing: border-box;
            & > span {
              color: #999999;
            }
          }
        }
      }
    }
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
</style>
